import { clsx } from 'clsx'
import { Img } from 'component/Image'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { SyntheticEvent, useState } from 'react'
import { InferenceStore } from 'store/inference/InferenceStore'
import { Size } from 'util/size'
import css from './Image.module.scss'

type Props = {
  inference: InferenceStore
  onGood?: (good: boolean) => void
  onSize?: (size: Size) => void
  preview?: boolean
  imageRef?(element: HTMLImageElement | null): void
}

export const Image = observer(({ inference, onGood, onSize, preview, imageRef }: Props) => {
  const source = inference.sources[0]
  const [good, setGood] = useState(false)
  const className = clsx(css.image, good && css.good, preview && css.preview)

  const onLoad = useLatestCallback((event: SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth: width, naturalHeight: height } = event.currentTarget
    setGood(true)
    if (onGood) onGood(true)
    if (onSize) onSize({ width, height })
  })

  const onError = useLatestCallback(() => {
    setGood(false)
    onGood?.(false)
  })

  return <Img onRef={imageRef} className={className} src={source} onLoad={onLoad} onError={onError} />
})
